module.exports = __webpack_public_path__ + "static/lenth-0a3fc5c25084c648dd644518f1b17365.svg";